import { FacilityOptionConfig } from 'common/lib/model/facility/FacilityOptions';

export interface EditableFacilityOption extends Pick<FacilityOptionConfig, 'inputType'> {
    optionValue?: string;
}

export function formatFacilityOptionValueForEditing(option: EditableFacilityOption) {
    if (option.inputType !== 'email-list') {
        return option.optionValue || '';
    }

    return parseEmailListOptionValue(option.optionValue).join('\n');
}

export function formatFacilityOptionValueForSubmit(option: Pick<FacilityOptionConfig, 'inputType'>, optionValue: string) {
    if (option.inputType !== 'email-list') {
        return optionValue || '';
    }

    return JSON.stringify(parseEmailListOptionValue(optionValue));
}

function parseEmailListOptionValue(optionValue: string) {
    const rawValue = String(optionValue || '').trim();
    if (!rawValue) {
        return [];
    }

    try {
        const parsedValue = JSON.parse(rawValue);
        if (Array.isArray(parsedValue)) {
            return normalizeEmailList(parsedValue);
        }
    } catch {
        // User-edited values can be entered as one email per line instead of raw JSON.
    }

    return normalizeEmailList(rawValue.split(/[\n,;]+/));
}

function normalizeEmailList(values: unknown[]) {
    return values.map((value) => String(value).trim()).filter(Boolean);
}
